import memoize from 'memoizee'
import { isEmpty } from '../utils/common'

export const getSSDAccommodationsForStudent = memoize((state, studentId) => {
  const selectedStudentAccommodations = state.studentSSDAccommodations.accommodations[studentId]
  return isEmpty(selectedStudentAccommodations) ? [] : selectedStudentAccommodations
})
